import gql from 'graphql-tag';

const NewsQuery = {
  getAllNews: gql`
    query findNewsAll($setLimit: Int, $page: Int) {
      findNewsAll(setLimit: $setLimit, page: $page) {
        id
        title
        newsCategory
        annotation
        text
        date
        attachmentsItem {
          tempFullFilePath
        }
      }
    }
  `,
  getSingleNews: gql`
    query findNewsById($id: Int!) {
      findNewsById(id: $id) {
        totalCount
        id
        title
        date
        newsCategory
        annotation
        text
        is_charity
        attachmentsItem {
          tempFullFilePath
        }
      }
    }
  `,
  getCommentsNews: gql`
    query findNewsCommentsById($id: Int!, $setLimit: Int, $page: Int) {
      findNewsCommentsById(id: $id, setLimit: $setLimit, page: $page) {
        totalCount
        commentsItem {
          id
          date
          text
          answer
          answer_user_id
          answer_date
          peopleItem {
            id
            fio
            attachmentsItem {
              cacheItem {
                filePath
              }
            }
          }
          answerUserItem {
            id
            secondname
            fio
            attachmentsItem {
              cacheItem {
                filePath
              }
            }
          }
        }
      }
    }
  `,
  getCountNewsItems: gql`
    query countNewsItems {
      countNewsItems
    }
  `
};

export default NewsQuery;
